<template>
  <div class="gift-form-detail">
    <div class="gift-head">{{ $t("giftyourself") }}</div>
    <span class="gift-img">
      <img src="../assets/images/gift.svg" />
    </span>
    <div class="gift-form">
      <label class="mobile-no">{{ $t("mobilenumber") }}</label>
      <input
        type="number"
        :placeholder="$t('mobilenumber')"
        required="required"
        class="textarea"
        v-model="mobile_no"
      />
    </div>
    <div class="gift-form">
      <label class="mobile-no">{{ $t("enteramountgold") }}</label>
      <input
        type="number"
        class="textarea"
        @input="getGoldinGram"
        v-model="value"
        required="required"
      />
      <span>{{ inGrams > 0 ? inGrams + " gm" : "Gold in Gram" }}</span>
    </div>
    <div class="gift-form">
      <Button class="button gold-gift-btn" @giftButton="sendgift()" :btn_txt="$t('goldgift')"></Button>
    </div>
    <div class="loader" v-if="loading">
      <img src="https://cdn.mall91.com/9ca91a3c-b750-4f95-854b-15588473cc97.gif" />
    </div>
  </div>
</template>
<script>
import { mapGetters } from "vuex";
import Button from "../components/Button";
import { toaster, roundDown, roundOff, getGramBySellingPrice } from "../utils/helper";
import { isMobileNumber } from "../utils/validators";
import { SessionHelper } from "../utils/session"

export default {
  name: "GiftDetails",
  components: {
    Button
  },
  data() {
    return {
      inGrams: 0,
      mobile_no: "",
      value: "",
      loading: false
    };
  },
  computed: {
    ...mapGetters(["user", "isUserAuthorized"])
  },
  props: {
    currentprice: Number
  },
  methods: {
    roundDown,
    getGoldinGram() {
      this.inGrams = getGramBySellingPrice(this.value, this._sellignPrice)
    },
    async sendgift() {
      if (!isMobileNumber(this.mobile_no)) {
        toaster(this, this.$t("entervalid_mobileno"), "top-left", 2000);
        return;
      } else if (!this.value) {
        toaster(this, this.$t("enter_goldamount"), "top-left", 2000);
        return;
      } else if (this.inGrams > this.user.total_gold_amount) {
        toaster(this, this.$t("enough_gold"), "top-left", 2000);
        return;
      }
      if (!this._sellignPrice) {
        toaster(this, this.$t("somethingwentwrong"), "top-left", 2000);
        return;
      }
      SessionHelper.refereshJwtToken()
      await this.$store
      .dispatch({ type: "getGoldAmount" })
      .then(data => {
        this._sellignPrice = data.data.data.selling_record.current_price;
      })
      .catch(err => {
        this._sellignPrice = 0;
        toaster(this, this.$t("somethingwentwrong"), "top-left", 2000);
      });
      const obj = {
        receiver_phone_number: this.mobile_no,
        tipping_gold_amount: Number(this.value),
        sell_price: this._sellignPrice
      };
      this.loading = !this.loading;
      await this.$store
        .dispatch({ type: "gifting", payload: obj })
        .then(data => {
          this.loading = !this.loading;
          this.mobile_no = "";
          this.value = "";
          this.inGrams = 0;
          toaster(this, this.$t("successfully_giftedgold"), "top-left", 2000);
          this.$emit('historyCallback')
        })
        .catch(err => {
          this.loading = !this.loading;
          this.mobile_no = "";
          this.value = "";
          this.inGrams = 0;
          if (err.response.status === 400 || err.response.status === 404) {
            toaster(this, this.$t("receiver_notregister"), "top-left", 2000);
          } else if (err.response.status === 401) {
            SessionHelper.refereshJwtToken()
          } else {
            toaster(this, this.$t("somethingwentwrong"), "top-left", 2000);
          }
        });
    }
  },
  beforeMount() {
    this.$store
      .dispatch({ type: "getGoldAmount" })
      .then(data => {
        this._sellignPrice = data.data.data.selling_record.current_price;
      })
      .catch(err => {
        this._sellignPrice = 0;
        toaster(this, this.$t("somethingwentwrong"), "top-left", 2000);
      });
  }
};
</script>
